import MenuItem from "~/cabinet/vue/interface/menu/MenuItem";
import {RouteLocationNamedRaw, RouteLocationNormalized, RouteRecordRaw} from "vue-router";
import {IRouteMeta} from "~/core-ui/ts/router/Interface";

export const DASHBOARD_ID = "dashboardId";

export default class DashboardRouteBuilder {
    public static getMenu(routeName: string, descr: string = "Сводка"): MenuItem {
        return (new MenuItem(routeName, descr))
        //.setIcon("tachometer-alt")
    }

    public static getRouteConfig(routeName: string, dashboardTypeId: () => string, keepAlive?: boolean, path: string = "dashboard"): RouteRecordRaw {
        const dashboardRouteName = `${routeName}_dashboard`;
        return {
            name: routeName,
            path: path,
            component: () => import(/* webpackChunkName: "dashboard" */ '~/cabinet/vue/client/dashboard/Dashboards.vue'),
            props: () => ({
                typeId: dashboardTypeId(),
                getRawLocationByDashboardId: (dashboardId: string) => {
                    return {
                        name: dashboardRouteName,
                        params: {
                            typeId: dashboardTypeId(),
                            [DASHBOARD_ID]: dashboardId
                        }
                    } as RouteLocationNamedRaw;
                }
            }),
            children: [
                {
                    name: dashboardRouteName,
                    path: `:${DASHBOARD_ID}`,
                    props: (route: RouteLocationNormalized) => ({
                        typeId: dashboardTypeId(),
                        [DASHBOARD_ID]: route.params[DASHBOARD_ID]
                    }),
                    children: []
                }
            ],
            meta: {
                keepAlive
            } as IRouteMeta
        } as RouteRecordRaw;
    }
}

export function getCurrentDashboardIdFromRoute(route: RouteLocationNormalized): string | null {
    return route.params[DASHBOARD_ID] as string;
}